<template>
    <el-dialog
        :title="title"
        :width="width"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'PerformanceUploadDialog'"
    >
        <el-form
            ref="attachmentForm"
            :model="attachmentForm"
            :rules="attachmentFormRules"
            label-width="60px"
        >
            <el-form-item label="附件：" prop="downUrl">
                <upload-new-btn
                    class="upload"
                    ref="uploadButton"
                    type="btn"
                    businessKey="default"
                    bucket="c-tms"
                    contentType="application/octet-stream"
                    :needBtn="true"
                    :text="'请选择文件'"
                    :publicRead="1"
                    :compressImage="true"
                    :compressQuality="0.5"
                    :showFileLists="true"
                    :before-upload="beforeUpload"
                    :on-remove="handleRemove"
                    @callback="uploadResponse"
                >
                </upload-new-btn>
                <el-input v-model="attachmentForm.downUrl" v-show="false" />
            </el-form-item>
        </el-form>
        <div class="uploadTips">
            <p>
                <span>注意事项1：</span>
                <span class="tipsValue">上传附件的大小不能超过20M。</span>
            </p>
            <p>
                <span>注意事项2：</span>
                <span class="tipsValue"
                    >文件格式为.jpg,.jpeg,png,.xlsx,.doc,.pdf。</span
                >
            </p>
        </div>
        <template #footer>
            <div>
                <el-button @click="handleUpload" :loading="loading">
                    上传
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';
export default {
    name: 'PerformanceUploadDialog',
    components: {
        UploadNewBtn
    },
    props: {
        title: {
            type: String,
            default: '附件上传页面'
        },
        width: {
            type: String,
            default: '450px'
        }
    },
    data () {
        return {
            loading: false, // 上传按钮加载动画
            attachmentForm: {
                downUrl: '',
                fileSize: 0
            },
            fileList: [], // 上传的文件列表
            attachmentFormRules: {
                downUrl: [{ required: true, message: '请选择附件', trigger: ['change', 'blur'] }]
            }
        };
    },
    methods: {
        /**
         * @description 获取文件后缀名
         * @param {String} fileName 文件名称
         */
        getFileExt (fileName) {
            return fileName && fileName.replace(/^.*\./, '').toLowerCase();
        },
        /**
         * @description 上传之前判断文件名和文件大小是否符合指定条件
         * @param {Array} extArr 文件后缀名
         * @param {Number} isLt20M 文件限制大小
         */
        beforeUpload (file) {
            var extArr = ['jpg', 'jpeg', 'png', 'doc', 'docx', 'xlsx', 'pdf'];
            if (!extArr.includes(this.getFileExt(file.name))) {
                this.$message({
                    type: 'warning',
                    message: '文件格式只能为 JPG / JPEG / PNG / DOC / DOCX / XLSX / PDF',
                    duration: 5000,
                    showClose: true
                });
                this.$refs.uploadButton.handleUploadStatus(false);
                this.handleDeleteErrorFile(file);
                return false;
            }
            this.$refs.uploadButton.handleUploadStatus(true);
            const uploadFiles = this.$refs.uploadButton.$refs.ossElUpload.uploadFiles;
            // 文件大小 / 1024 = 转kb
            this.attachmentForm.fileSize = (file.size / 1024).toFixed(1);
            // 每次只能上传一个文件，将上一次上传的文件替换掉
            uploadFiles.splice(0, uploadFiles.length, file);
            this.loading = true;
        },
        /**
         * @description 清除不符合规格的文件
         */
        handleDeleteErrorFile (file) {
            this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.forEach((e, i) => {
                if (file.name === e.name) {
                    this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.splice(i, 1);
                }
            });
            this.$refs.uploadButton.uploadDataArr.forEach((e, i) => {
                if (file.name === e.file.name) {
                    this.$refs.uploadButton.uploadDataArr.splice(i, 1);
                }
            });
        },
        /**
         * @description 文件上传成功回调
         * @param response oss响应回来的数据
         * @param {Array} fileList 上传的文件列表
         */
        uploadResponse (response) {
            this.loading = false;
            if (response && +response.code === 0) {
                this.attachmentForm.downUrl = response.data.downUrl;
                this.attachmentForm.name = response.data.name;
                this.fileList.push(response.data);
            }
        },
        /**
         * @description 移除文件
         * @param {Object} file 移除的文件
         * @param {Array} fileList 剩余未移除的文件列表
         */
        handleRemove (file, fileList) {
            this.fileList = this.fileList.filter(v => (v.name !== file.name));
            this.attachmentForm.downUrl = this.fileList.length > 0 ? this.fileList[0].downUrl : '';
        },
        /**
         * @description 上传
         * @param {Array} urlArr 文件的downUrl集合
         */
        handleUpload () {
            Promise.resolve(this.$refs.attachmentForm.validate()).then(() => {
                // const urlArr = this.fileList.map(v => v.downUrl);
                this.$emit('uploadSuccess', this.attachmentForm);
            }).catch(() => { });
        },
        beforeClose () {
            this.$emit('update:attachmentUploadVisible', false);
        }
    }
};
</script>
<style lang="less">
.PerformanceUploadDialog {
    .el-dialog__body {
        padding-top: 30px;
    }
    .uploadTips {
        padding-top: 10px;
        & > p {
            margin: 5px 0;
        }
        .tipsValue {
            color: rgb(255, 0, 0);
        }
    }
    .el-upload-list__item {
        transition: none;
    }
}
</style>
